window.app.factory("$elementPosition", [
  function() {
    return {
      absoluteY: getAbsoluteY
    };

    function getAbsoluteY(event, offset) {
      var clientY = event.target.getBoundingClientRect().top;
      return clientY - (offset || 0);
    }
  }
]);

window.app.run([
  "$rootScope",
  "$elementPosition",
  function($rootScope, $elementPosition) {
    $rootScope.$elementPosition = $elementPosition;
  }
]);



// WEBPACK FOOTER //
// ./src/services/elementPosition.js